import { getApiBase } from "_helpers";
import { cookieService } from "_services";
import { uniqueId } from "_helpers";

const getAllClaims = (
  page,
  rowsPerPage,
  filterParams,
  search,
  searchField,
  searchFields,
  isDispatchAdmin,
  allClaimsCount,
  restrictedStatusIds
) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  const apiBase = getApiBase();

  const jwtCookie = process.env.NODE_ENV !== "production" ? `&jwtCookie=${encodeURI(cookieService.get("token"))}` : "";

  const restrictedStatusIdsParam = restrictedStatusIds?.length > 0 ? `&restrictedStatusIds=${restrictedStatusIds}` : "";

  const searchFieldsParam = `&searchFields=${encodeURI(JSON.stringify(searchFields.map((field) => field.value)))}`;

  const searchFieldParam = searchField ? `&searchField=${searchField}` : "";

  return fetch(
    `${apiBase}/tel/claims?rows=${rowsPerPage}&page=${page}${allClaimsCount ? allClaimsCount : ""}${filterParams}${
      search ? `&search=${encodeURI(search)}` : ""
    }${
      isDispatchAdmin ? "&dispatchAdmin=true" : ""
    }${restrictedStatusIdsParam}${searchFieldsParam}${searchFieldParam}${jwtCookie}`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("No claims matching search");
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getMyClaims = (
  page,
  rowsPerPage,
  filterParams,
  search,
  searchField,
  searchFields,
  isDispatchAdmin,
  allClaimsCount,
  userLogginIn
) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  const apiBase = getApiBase();

  const jwtCookie = process.env.NODE_ENV !== "production" ? `&jwtCookie=${encodeURI(cookieService.get("token"))}` : "";

  const searchFieldsParam = `&searchFields=${encodeURI(JSON.stringify(searchFields.map((field) => field.value)))}`;

  const searchFieldParam = searchField ? `&searchField=${searchField}` : "";

  return fetch(
    `${apiBase}/tel/myclaims?rows=${rowsPerPage}&page=${page}${allClaimsCount ? allClaimsCount : ""}${filterParams}${
      search ? `&search=${encodeURI(search)}` : ""
    }${
      isDispatchAdmin ? "&dispatchAdmin=true" : ""
    }&userID=${userLogginIn}${searchFieldsParam}${searchFieldParam}${jwtCookie}`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("No claims found for this user");
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getMyTeamsClaims = (
  page,
  rowsPerPage,
  filterParams,
  search,
  searchField,
  searchFields,
  isDispatchAdmin,
  allClaimsCount,
  userLogginIn
) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  const apiBase = getApiBase();

  const jwtCookie = process.env.NODE_ENV !== "production" ? `&jwtCookie=${encodeURI(cookieService.get("token"))}` : "";

  const searchFieldsParam = `&searchFields=${encodeURI(JSON.stringify(searchFields.map((field) => field.value)))}`;

  const searchFieldParam = searchField ? `&searchField=${searchField}` : "";

  return fetch(
    `${apiBase}/tel/myteamclaims?rows=${rowsPerPage}&page=${page}${
      allClaimsCount ? allClaimsCount : ""
    }${filterParams}${search ? `&search=${encodeURI(search)}` : ""}${
      isDispatchAdmin ? "&dispatchAdmin=true" : ""
    }&userID=${userLogginIn}${searchFieldsParam}${searchFieldParam}${jwtCookie}`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("No claims found for this user's teams");
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getMyMobileClaims = (page, rowsPerPage, filterParams, search, searchField, searchFields, restrictedStatusIds) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  const apiBase = getApiBase();

  const jwtCookie = process.env.NODE_ENV !== "production" ? `&jwtCookie=${encodeURI(cookieService.get("token"))}` : "";

  const restrictedStatusIdsParam = restrictedStatusIds.length > 0 ? `&restrictedStatusIds=${restrictedStatusIds}` : "";

  const searchFieldsParam = `&searchFields=${encodeURI(JSON.stringify(searchFields.map((field) => field.value)))}`;

  const searchFieldParam = searchField ? `&searchField=${searchField}` : "";

  return fetch(
    `${apiBase}/tel/internalmobile/myclaims?rows=${rowsPerPage}&page=${page}${filterParams}${
      search ? `&search=${encodeURI(search)}` : ""
    }${restrictedStatusIdsParam}${searchFieldsParam}${searchFieldParam}${jwtCookie}`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("No claims matching search");
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimById = (claimId, restrictedStatusIds) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache", // Tells proxies/browsers not to cache
      Pragma: "no-cache", // Legacy HTTP 1.0 cache-busting header
    },
    cache: "no-store", // Fetch API directive to always go to network
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  let restrictedStatusIdsParam = "";
  if (restrictedStatusIds?.length > 0) {
    restrictedStatusIdsParam = `&restrictedStatusIds=${restrictedStatusIds}`;
  }

  return fetch(`${apiBase}/tel/claim?claimid=${claimId}${restrictedStatusIdsParam}${jwtCookie}`, parameters)
    .then(async (response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }

      const responseObj = await response.json();

      if (response.status !== 200) {
        if (responseObj.reason) {
          const initialUrl = window.location.href;

          window.history.pushState(window.history.state, "", `${claimId}/access-denied/${responseObj.reason}`);
          window.history.go(0);
          window.history.pushState(window.history.state, "", initialUrl);
          throw new Error(`Access Denied`);
        } else {
          throw new Error(`error fetching claim ${claimId}`);
        }
      }

      return responseObj;
    })
    .catch((err) => {
      throw err;
    });
};
const getRelatedClaims = (claimId) => {
  const parameters = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let url = `${apiBase}/tel/claim/relatedclaims?claimid=${claimId}`;

  if (process.env.NODE_ENV !== "production") {
    url += `&jwtCookie=${cookieService.get("token")}`;
  }

  return fetch(url, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};
const updateClaim = (claimId, payload, useNewRDA) => {
  let body = {
    ...payload,
  };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  // let apiBase = "http://localhost:3000/api"; // local host testing
  let apiBase = getApiBase();

  return fetch(`${apiBase}/tel/updateclaim?claimid=${claimId}&useNewRDA=${useNewRDA}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      return { status: response.status, claimId };
    })
    .catch((err) => {
      throw err;
    });
};

const deleteClaim = (claimId, restrictedStatusIds, trackChanges, data, callback) => {
  let body = {
    // 276: 1, // set inActive field to true
    trackChanges,
    data,
  };

  if (restrictedStatusIds.length > 0) {
    body.restrictedStatusIds = restrictedStatusIds;
  }

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();

  return fetch(`${apiBase}/tel/deleteclaim?claimid=${claimId}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (callback) callback();
      return { status: response.status, claimId };
    })
    .catch((err) => {
      throw err;
    });
};

const createClaim = (payload) => {
  let body = { ...payload };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  // let apiBase = "http://localhost:3000/api"; // local host testing
  let apiBase = getApiBase();

  return fetch(`${apiBase}/tel/create`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("Error creating claim");
      }

      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getCreateClaimFieldRules = (entityId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/schema/create?entityid=${entityId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("error fetching field meta data");
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getSchemaEntityOptions = (subroute) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  const apiBase = getApiBase();
  const jwtCookie = process.env.NODE_ENV !== "production" ? `?jwtCookie=${encodeURI(cookieService.get("token"))}` : "";

  return fetch(`${apiBase}/tel/schema/entityoptions${subroute ?? ""}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching entity options}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getSchemaRdaOptions = (entityId, getAll) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/schema/rda?entityid=${entityId}&getall=${getAll}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching rda options}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getFilterSets = () => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/filters/save${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("error fetching saved filter sets");
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const createFilterSet = (payload) => {
  let body = { ...payload };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();

  return fetch(`${apiBase}/tel/filters/save`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("Error filter set");
      }

      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const removeFilterSet = (id) => {
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/filters/save?filterid=${id}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("Error deleting collection");
      }

      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const updateFilterSet = (filterSetId, payload) => {
  let body = {
    ...payload,
  };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();

  return fetch(`${apiBase}/tel/filters/save?filterid=${filterSetId}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("Error updating filter set information");
      }

      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const checkFilterSetName = (base, name) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/filters/save/name?base=${base}&name=${name}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("error checking filter set name");
      }
      return { ...response.json(), status: response.status };
    })
    .catch((err) => {
      throw err;
    });
};

const duplicateFilterSet = (id, name) => {
  let body = { name };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();

  return fetch(`${apiBase}/tel/filters/save/duplicate?filterid=${id}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("Error duplicating filter set");
      }

      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const uploadFile = (image, { claimId, categoryId, type, privateFile, category, parentCategory, userId, username }) => {
  const dataFile = new FormData();

  const originalFileName = image.name.substr(0, image.name.lastIndexOf("."));
  const fileTypeNative = image.name.substr(image.name.lastIndexOf(".")).toLowerCase();

  // Append base fields
  dataFile.append("file", image, `${claimId} - ${uniqueId.next()}`);
  dataFile.append("fileName", `${claimId} - ${category}`);
  dataFile.append("userid", `${userId}`);
  dataFile.append("username", `${username}`);
  dataFile.append("claimId", claimId);
  dataFile.append("categoryId", categoryId);
  dataFile.append("parentCategory", parentCategory);
  dataFile.append("originalFileName", originalFileName);
  dataFile.append("active", true);
  dataFile.append("lob", "TEL");
  dataFile.append("fileTypeNative", fileTypeNative);

  if (process.env.NODE_ENV !== "production") {
    dataFile.append("jwtCookie", cookieService.get("token"));
  }

  const parameters = {
    method: "POST",
    credentials: "include",
    body: dataFile,
  };

  let apiBase = getApiBase();
  // CHANGED: Return the JSON response with jobId
  return fetch(`${apiBase}/claim/upload-telecom`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (!response.ok) {
        throw new Error(`Upload failed with status ${response.status}`);
      }
      return response.json(); // Returns { jobId, status: "queued", message: "..." }
    })
    .catch((err) => {
      throw err;
    });
};

const handleSaveRotation = ({ file, GCSPath, claimId, fileID, fk_categoryID }) => {
  const dataFile = new FormData();
  dataFile.append("file", file);
  dataFile.append("claimId", claimId);
  dataFile.append("lob", "TEL");
  dataFile.append("GCSPath", GCSPath);
  dataFile.append("fileID", fileID);
  dataFile.append("fk_categoryID", fk_categoryID);
  if (process.env.NODE_ENV !== "production") {
    dataFile.append("jwtCookie", cookieService.get("token"));
  }
  const parameters = {
    method: "POST",
    credentials: "include",
    body: dataFile,
  };
  let apiBase = getApiBase();
  return fetch(`${apiBase}/claim/saveFileRotation`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("Error saving file rotation");
      }
      return {};
    })
    .catch((err) => {
      throw err;
    });
};

const getFiles = (startOffset) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
      Expires: "0",
    },
    credentials: "include",
  };

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  let apiBase = getApiBase();
  return fetch(`${apiBase}/claim/files?offset=${startOffset}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("error fetching attachments");
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const sortOrder = (payload) => {
  let body = {
    ...payload,
  };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
    };
  }

  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/claim/saveindex${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }

      if (response.status !== 204) {
        throw new Error("Error Updating Order");
      }

      return response;
    })
    .catch((err) => {
      throw err;
    });
};

const updateCategory = (payload) => {
  let body = {
    ...payload,
  };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
    };
  }

  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/claim/savecategory${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }

      if (response.status !== 200) {
        throw new Error("Error Updating Categories");
      }

      return response;
    })
    .catch((err) => {
      throw err;
    });
};

const getSignedUrl = (path) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  let apiBase = getApiBase();
  return fetch(`${apiBase}/claim/file?path=${path}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("error fetching attachments");
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const logFileAccess = (payload) => {
  const parameters = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
  };

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  let apiBase = getApiBase();
  return fetch(`${apiBase}/claim/logfileaccess${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) throw new Error("Invalid Auth Token");
      if (response.status !== 200) throw new Error("Error logging file access");
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const postPayment = (payload, claimId) => {
  let body = {
    ...payload,
  };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();

  return fetch(`${apiBase}/tel/payment/save?claimid=${claimId}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }

      if (response.status !== 200) {
        throw new Error("Error posting payment");
      }

      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimHistory = (claimId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claimhistory?claimid=${claimId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching rda options}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};
/**
 *
 * @param {*} claimId
 * @param {*} ccma Charter Comcast Mdediacom Optimum
 * @returns
 */
const getJobCostingInvoice = async (claimId, ccma) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  try {
    const response = await fetch(
      `${apiBase}/tel/claim/invoice?claimid=${claimId}&ccma=${ccma}${jwtCookie}`,
      parameters
    );
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }
    if (response.status !== 200) {
      throw new Error(`error fetching TEL ${claimId} Invoice}`);
    }
    return await response.json();
  } catch (err) {
    throw err;
  }
};

const getClaimJobCostingRateCardContractor = (claimId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/ratecard/misc?claimid=${claimId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching error fetching contractor`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimJobCostingRateCardMaterial = (claimId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/ratecard/material?claimid=${claimId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching material rate card`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimJobCostingRateCardLabor = (claimId, ccma) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/ratecard/labor?claimid=${claimId}&ccma=${ccma}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching Labor Rate Card}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const putConstructionCostsCompleted = async (claimId, constructionCostCompleted) => {
  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  let body = { constructionCostCompleted };
  if (process.env.NODE_ENV !== "production") {
    body.jwtCookie = cookieService.get("token");
  }

  const response = await fetch(`${apiBase}/tel/claim/invoice/constructioncosts?claimid=${claimId}${jwtCookie}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(body),
  });
  if (response.status === 403) throw new Error("Invalid Auth Token");
  if (response.status !== 200) throw new Error("Error updating construction cost completed");
  return response.json();
};

const getClaimJobCostingFlatRates = (claimId, locateCompany) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(
    `${apiBase}/tel/claim/ratecard/flatrates?claimid=${claimId}&locateCompany=${locateCompany}${jwtCookie}`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching USIC Rate Card}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

let claimInvoiceTimeStamp = (claimId) => {
  let body = {};

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();

  return fetch(`${apiBase}/tel/claim/invoice?claimid=${claimId}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }

      if (response.status !== 200) {
        throw new Error("Error creating invoice id");
      }

      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const postClaimInHouseLaborItem = async (payload, claimId, invoiceId, ccma, entityid) => {
  let body = {
    ...payload,
  };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  try {
    const response = await fetch(
      `${apiBase}/tel/claim/invoice/labor?claimid=${claimId}&invoiceid=${invoiceId}&ccma=${ccma}&entityid=${entityid}`,
      parameters
    );
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }

    if (response.status !== 200) {
      throw new Error("Error posting payment");
    }
    return await response.json();
  } catch (err) {
    throw err;
  }
};

const postClaimMaterialItem = async (payload, claimId, invoiceId, ccma, entityid) => {
  let body = {
    ...payload,
  };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  try {
    const response = await fetch(
      `${apiBase}/tel/claim/invoice/material?claimid=${claimId}&invoiceid=${invoiceId}&ccma=${ccma}&entityid=${entityid}`,
      parameters
    );
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }

    if (response.status !== 200) {
      throw new Error("Error posting material item");
    }
    return await response.json();
  } catch (err) {
    throw err;
  }
};

const postClaimOtherItem = (payload, claimId, invoiceId) => {
  let body = {
    ...payload,
  };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  return fetch(`${apiBase}/tel/claim/invoice/other?claimid=${claimId}&invoiceid=${invoiceId}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }

      if (response.status !== 200) {
        throw new Error("Error posting payment");
      }

      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const postClaimUnlistedItem = async (payload, claimId, entityId, invoiceId) => {
  let body = {
    ...payload,
  };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  try {
    const response = await fetch(
      `${apiBase}/tel/claim/invoice/unlisted?claimid=${claimId}&invoiceId=${invoiceId}&entityId=${entityId}`,
      parameters
    );
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }

    if (response.status !== 200) {
      throw new Error("Error posting payment");
    }
    return await response.json();
  } catch (err) {
    throw err;
  }
};

const postClaimContractorItem = async (payload, claimId, invoiceId, ccma, entityid) => {
  let body = {
    ...payload,
  };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  try {
    const response = await fetch(
      `${apiBase}/tel/claim/invoice/contractor?claimid=${claimId}&invoiceid=${invoiceId}&ccma=${ccma}&entityid=${entityid}`,
      parameters
    );
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }

    if (response.status !== 200) {
      throw new Error("Error posting payment");
    }
    return await response.json();
  } catch (err) {
    throw err;
  }
};

const postClaimLOItem = (payload, claimId, invoiceId, entityId) => {
  let body = {
    ...payload,
  };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  return fetch(
    `${apiBase}/tel/claim/invoice/lo?claimid=${claimId}&invoiceid=${invoiceId}&entityid=${entityId}`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }

      if (response.status !== 200) {
        throw new Error("Error posting payment");
      }

      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const jobCostingRemoveOtherItem = (itemId, invoiceId) => {
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(
    `${apiBase}/tel/claim/invoice/other?invoiceid=${invoiceId}&invoiceotheritemid=${itemId}${jwtCookie}`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("error removing other item");
      }
      return { id: itemId, status: response.status };
    })
    .catch((err) => {
      throw err;
    });
};

const jobCostingRemoveLaborItem = async (itemId, invoiceId, ccma) => {
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  try {
    const response = await fetch(
      `${apiBase}/tel/claim/invoice/labor?invoiceid=${invoiceId}&invoicelaboritemid=${itemId}&ccma=${ccma}${jwtCookie}`,
      parameters
    );
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }
    if (response.status !== 200) {
      throw new Error("error removing labor item");
    }
    return { id: itemId, status: response.status };
  } catch (err) {
    throw err;
  }
};

const jobCostingRemoveMaterialItem = async (itemId, invoiceId, ccma) => {
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  try {
    const response = await fetch(
      `${apiBase}/tel/claim/invoice/material?invoiceid=${invoiceId}&invoicematerialitemid=${itemId}&ccma=${ccma}${jwtCookie}`,
      parameters
    );
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }
    if (response.status !== 200) {
      throw new Error("error removing material item");
    }
    return { id: itemId, status: response.status };
  } catch (err) {
    throw err;
  }
};

const jobCostingRemoveContractorItem = async (itemId, invoiceId, ccma) => {
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  try {
    const response = await fetch(
      `${apiBase}/tel/claim/invoice/contractor?invoiceid=${invoiceId}&invoicecontractoritemid=${itemId}&ccma=${ccma}${jwtCookie}`,
      parameters
    );
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }
    if (response.status !== 200) {
      throw new Error("error removing contractor item");
    }
    return { id: itemId, status: response.status };
  } catch (err) {
    throw err;
  }
};

const jobCostingRemoveLOItem = (itemId, invoiceId, claimId, entityId) => {
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(
    `${apiBase}/tel/claim/invoice/lo?invoiceid=${invoiceId}&invoiceloitemid=${itemId}&claimid=${claimId}&entityid=${entityId}${jwtCookie}`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("error removing contractor item");
      }
      return { id: itemId, status: response.status };
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimRepairCosts = async (claimId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  try {
    const response = await fetch(`${apiBase}/tel/claim/repair-costs?claimid=${claimId}${jwtCookie}`, parameters);
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }
    if (response.status !== 200) {
      throw new Error("error fetching repair costs");
    }
    return await response.json();
  } catch (err) {
    throw err;
  }
};

const postRepairCostLabor = async (data, claimId, entityId) => {
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  try {
    const response = await fetch(
      `${apiBase}/tel/claim/repair-costs/labor?claimid=${claimId}&entityid=${entityId}${jwtCookie}`,
      parameters
    );
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }
    if (response.status !== 200) {
      throw new Error("error posting repair cost labor item");
    }
    return await response.json();
  } catch (err) {
    throw err;
  }
};

const postRepairCostMaterial = async (data, claimId, entityId) => {
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  try {
    const response = await fetch(
      `${apiBase}/tel/claim/repair-costs/material?claimid=${claimId}&entityid=${entityId}${jwtCookie}`,
      parameters
    );
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }
    if (response.status !== 200) {
      throw new Error("error posting repair cost material item");
    }
    return await response.json();
  } catch (err) {
    throw err;
  }
};

const deleteRepairCostLabor = async (id, claimId) => {
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  try {
    const response = await fetch(
      `${apiBase}/tel/claim/repair-costs/labor?repaircostid=${id}&claimid=${claimId}${jwtCookie}`,
      parameters
    );
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }
    if (response.status !== 200) {
      throw new Error("error removing repair cost labor item");
    }
    return { id, status: response.status };
  } catch (err) {
    throw err;
  }
};

const deleteRepairCostMaterial = async (id, claimId) => {
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  try {
    const response = await fetch(
      `${apiBase}/tel/claim/repair-costs/material?repaircostid=${id}&claimid=${claimId}${jwtCookie}`,
      parameters
    );
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }
    if (response.status !== 200) {
      throw new Error("error removing repair cost material item");
    }
    return { id, status: response.status };
  } catch (err) {
    throw err;
  }
};

const getCostingStatusOptions = async (entityId) => {
  const parameters = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  try {
    const response = await fetch(
      `${apiBase}/tel/claim/repair-costs/costing-status?entityid=${entityId}${jwtCookie}`,
      parameters
    );
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }
    if (response.status !== 200) {
      throw new Error("error fetching costing status options");
    }
    return await response.json();
  } catch (err) {
    throw err;
  }
};

const uploadJobCostingFile = (file, name, claimId, userId, username) => {
  const dataFile = new FormData();

  dataFile.append("file", file, `${name} - ${uniqueId.next()}`);
  dataFile.append("fileName", `${name}`);
  dataFile.append("claimId", claimId);
  dataFile.append("parentCategory", "Assessment");
  dataFile.append("categoryId", 7);
  dataFile.append("userid", `${userId}`);
  dataFile.append("username", `${username}`);
  dataFile.append("fileTypeNative", ".pdf");
  dataFile.append("lob", "TEL");
  dataFile.append("active", true);

  if (process.env.NODE_ENV !== "production") {
    dataFile.append("jwtCookie", cookieService.get("token"));
  }

  const parameters = {
    method: "POST",
    credentials: "include",
    body: dataFile,
  };

  let apiBase = getApiBase();

  return fetch(`${apiBase}/claim/upload-telecom`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status === 202) {
        return response.json(); // Returns { jobId, status: "queued" }
      }
      throw new Error(`Upload failed with status ${response.status}`);
    })
    .catch((err) => {
      throw err;
    });
};

const claimUploadDocument = (file, name, claimId, userId, username, parent, category, fileType = ".pdf") => {
  const dataFile = new FormData();
  dataFile.append("file", file, `${name} - ${uniqueId.next()}`);
  dataFile.append("fileName", `${name}`);
  dataFile.append("claimId", claimId);
  dataFile.append("categoryId", category);
  dataFile.append("parentCategory", parent);
  dataFile.append("userid", `${userId}`);
  dataFile.append("username", `${username}`);
  dataFile.append("fileTypeNative", fileType);
  dataFile.append("lob", "TEL");
  dataFile.append("active", true);

  if (process.env.NODE_ENV !== "production") {
    dataFile.append("jwtCookie", cookieService.get("token"));
  }

  const parameters = {
    method: "POST",
    credentials: "include",
    body: dataFile,
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  return fetch(`${apiBase}/claim/upload-telecom`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }

      if (!response.ok) {
        throw new Error(`Upload failed with status ${response.status}`);
      }
      return response.json(); // Returns { jobId, status: "queued", message: "..." }
    })
    .catch((err) => {
      throw err;
    });
};
const checkUploadStatus = (jobId, lob, retryCount = 0, maxRetries = 5) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
      Expires: "0",
    },
    credentials: "include",
  };

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  let apiBase = getApiBase();

  // Exponential backoff
  const initialDelay = retryCount === 0 ? 300 : 300 * Math.pow(2, retryCount);

  return new Promise((resolve) => setTimeout(resolve, initialDelay))
    .then(() => {
      // Add LOB as query parameter
      return fetch(`${apiBase}/claim/upload-status/${jobId}?lob=${lob}${jwtCookie}`, parameters);
    })
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status === 404) {
        if (retryCount < maxRetries) {
          console.log(`Job not found, retrying (${retryCount + 1}/${maxRetries})...`);
          return checkUploadStatus(jobId, lob, retryCount + 1, maxRetries);
        }
        throw new Error("Job not found. It may have expired or the jobId is invalid.");
      }
      if (response.status !== 200) {
        throw new Error(`Status check failed with status ${response.status}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};
const claimConvertDocument = (file, name, outputFormat) => {
  // Validate required parameters
  if (!outputFormat) {
    throw new Error("outputFormat is required. Specify 'pdf', 'docx', 'html', etc.");
  }

  // Detect input file type from filename
  const getFileTypeFromName = (fileName) => {
    const extension = fileName.split(".").pop().toLowerCase();
    const extensionMap = {
      pdf: "pdf",
      doc: "doc",
      docx: "docx",
      html: "html",
      htm: "html",
      xls: "xls",
      xlsx: "xlsx",
      ppt: "ppt",
      pptx: "pptx",
      txt: "txt",
      rtf: "rtf",
    };
    return extensionMap[extension] || "pdf";
  };

  const inputFileType = getFileTypeFromName(name);

  const dataFile = new FormData();
  dataFile.append("file", file);
  dataFile.append("fileName", name);
  dataFile.append("originalname", name);
  dataFile.append("fileTypeNative", inputFileType);
  dataFile.append("outputFormat", outputFormat.toLowerCase());

  if (process.env.NODE_ENV !== "production") {
    dataFile.append("jwtCookie", cookieService.get("token"));
  }
  const parameters = {
    method: "POST",
    credentials: "include",
    body: dataFile,
  };
  let apiBase = getApiBase();
  return fetch(`${apiBase}/tel/claim/doc/convert`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (!response.ok) {
        return response.text().then((text) => {
          throw new Error(`Conversion failed: ${response.status} - ${text}`);
        });
      }
      return response.json();
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      throw err;
    });
};

const createWordDoc = (htmlString) => {
  const parameters = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ htmlString }),
  };

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${getApiBase()}/tel/claim/doc/createWordDoc`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }

      if (!response.ok) {
        return response.text().then((text) => {
          throw new Error(`Conversion failed: ${response.status} - ${text}`);
        });
      }

      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getInvoiceDoc = (claimId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/doc/template/payment?claimid=${claimId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching payment document ${claimId}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimDoc = (claimId, letterType, encodeContacts, encodeReason) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(
    `${apiBase}/tel/claim/doc/template/claim?claimid=${claimId}&lettertype=${letterType}${encodeContacts}${encodeReason}${jwtCookie}`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching claim document ${claimId}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimDocSchemaReason = async (entityId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  try {
    const response = await fetch(`${apiBase}/tel/claim/doc/schema/reason${jwtCookie}`, parameters);
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }
    if (response.status !== 200) {
      throw new Error(`error fetching reason options`);
    }
    return await response.json();
  } catch (err) {
    throw err;
  }
};

const addClaimDocSchemaReason = async (LetterReason) => {
  let body = { LetterReason };
  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  // let apiBase = "http://localhost:3000/api"; // local host testing
  let apiBase = getApiBase();

  try {
    const response = await fetch(`${apiBase}/tel/claim/doc/schema/reason`, parameters);
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }
    if (response.status !== 200) {
      throw new Error("Error creating claim");
    }
    return await response.json();
  } catch (err) {
    throw err;
  }
};

const editClaimDocSchemaReason = async (LRID, LetterReason) => {
  let body = { LetterReason };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  // let apiBase = "http://localhost:3000/api"; // local host testing
  let apiBase = getApiBase();

  try {
    const response = await fetch(`${apiBase}/tel/claim/doc/schema/reason?LRID=${LRID}`, parameters);
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }
    if (response.status !== 200) {
      throw new Error("Error editing Letter Reason");
    }
    return await response.json();
  } catch (err) {
    throw err;
  }
};

const removeClaimDocSchemaReason = async (LRID) => {
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  try {
    const response = await fetch(`${apiBase}/tel/claim/doc/schema/reason?LRID=${LRID}${jwtCookie}`, parameters);
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }
    if (response.status !== 200) {
      throw new Error("Error creating claim");
    }
    return await response.json();
  } catch (err) {
    throw err;
  }
};

const getClaimDocSchemaContacts = () => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/doc/schema/contacts${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching contact options`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimDocSchemaLastSentence = (entityId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/doc/schema/lastsentence?entityid=${entityId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching last sentence options`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimAttachmentSchemaImageCategory = () => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/schema/filetype/image${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching attachment file image schema`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimAttachmentSchemaVideoCategory = () => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/schema/filetype/video${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching attachment file video schema`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimAttachmentSchemaDocumentCategory = (parentType) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/schema/filetype/document?parentType=${parentType}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching attachment file video schema`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimDocSchemaDigLaws = (claimId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/doc/schema/dig-laws?claimId=${claimId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching dig laws options`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimNarrativeCreatorDoc = (claimId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/doc/template/narrative-creator?claimid=${claimId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching claim document ${claimId}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimIntentToBillDoc = (claimId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/doc/template/intent-to-bill?claimid=${claimId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching claim document ${claimId}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimPromissoryNoteDoc = (claimId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/doc/template/promissory-note?claimid=${claimId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching claim document ${claimId}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimLegalFinalNoticeDoc = (claimId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/doc/template/legal-notice?claimid=${claimId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching claim document ${claimId}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimFinalNoticeDoc = (claimId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/doc/template/final-notice?claimid=${claimId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching claim document ${claimId}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimReleaseLetterDoc = (claimId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/doc/template/release-letter?claimid=${claimId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching claim document ${claimId}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimSecondNoticeDoc = (claimId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/doc/template/second-notice?claimid=${claimId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching claim document ${claimId}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimPaymentReceiptDoc = (claimId, ledgerid) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(
    `${apiBase}/tel/claim/doc/template/payment-receipt?claimid=${claimId}&ledgerid=${ledgerid}${jwtCookie}`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching claim document ${claimId}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimBalanceOwedDoc = (claimId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/doc/template/balance-owed?claimid=${claimId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching claim document ${claimId}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

const getClaimPreLegalLetterDoc = (claimId) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/claim/doc/template/pre-legal-letter?claimid=${claimId}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error(`error fetching claim document ${claimId}`);
      }
      return response.json();
    })
    .catch((err) => {
      throw err;
    });
};

// const getLogo = (entityLogoName) => {
//   const parameters = {
//     method: "GET",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     credentials: "include",
//   };

//   let apiBase = getApiBase();
//   // let apiBase = "http://localhost:3000/api"; // local host testing
//   let jwtCookie = "";
//   if (process.env.NODE_ENV !== "production") {
//     jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
//   }

//   return fetch(
//     `${apiBase}/public/images?file=${entityLogoName}${jwtCookie}`,
//     parameters
//   )
//     .then((response) => {
//       if (response.status === 403) {
//         throw new Error("Invalid Auth Token");
//       }
//       if (response.status !== 200) {
//         throw new Error(`error fetching logo`);
//       }
//       return response.json();
//     })
//     .catch((err) => {
//       throw err;
//     });
// };
const deleteLedger = (ledgerId, claimId) => {
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/joint/ledger/delete?ledgerid=${ledgerId}&claimid=${claimId}&lobid=1${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("error removing ledger");
      }
      return { id: ledgerId, status: response.status };
    })
    .catch((err) => {
      throw err;
    });
};

const updateLedger = ({ id, ...payload }, watchId, cb) => {
  let body = {
    ...payload,
  };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  // let apiBase = "http://localhost:3000/api"; // local host testing
  let apiBase = getApiBase();

  return fetch(`${apiBase}/joint/ledger/put?ledgerId=${id}&claimid=${watchId}&lobid=1`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (cb) cb();
      return { status: response.status, id };
    })
    .catch((err) => {
      throw err;
    });
};

const deleteStatusNote = (watchId) => {
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/joint/statusnotes/delete?id=${watchId}&lobid=1${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("error removing  Status Note");
      }
      return { id: watchId, status: response.status };
    })
    .catch((err) => {
      throw err;
    });
};

const deleteActionNote = (actionId, claimId) => {
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  // let apiBase = "http://localhost:3000/api"; // local host testing

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(
    `${apiBase}/joint/actionnotes/delete?actionid=${actionId}&claimid=${claimId}&lobid=1${jwtCookie}`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (response.status !== 200) {
        throw new Error("error removing  Status Note");
      }
      return { id: claimId, status: response.status };
    })
    .catch((err) => {
      throw err;
    });
};

const saveColumnFilters = async (filters) => {
  const filterArr = Object.keys(filters).map((key) => {
    return { [key]: filters[key] };
  });
  let body = {
    filters: filterArr,
  };

  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();

  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  try {
    const response = await fetch(`${apiBase}/joint/claimcolumns?lobid=1${jwtCookie}`, parameters);
    if (response.status === 403) {
      throw new Error("Invalid Auth Token");
    }
    if (response.status !== 200) {
      throw new Error("error saving column filters");
    }
    return { status: response.status };
  } catch (err) {
    throw err;
  }
};

//KML file related services (some of these will move to admin related services in the future)

/**
 * Validate address against KML boundaries
 */
const validateAddress = (data) => {
  let body = {
    ...data,
    // The backend now handles coordinate inclusion by default, so 'includeCoordinates' is not strictly needed.
    // It can be kept for clarity or removed.
    includeCoordinates: true,
  };

  // For local development, include the JWT token from cookies if not in production.
  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  const apiBase = getApiBase();
  const endpoint = `${apiBase}/tel/kml/validate-address`;

  return fetch(endpoint, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }

      if (!response.ok) {
        return response.json().then((errorData) => {
          // Re-throw the error with the server's message to be caught by the component.
          const error = new Error(errorData.message || "Address validation failed");
          error.response = errorData; // Attach the full response for more detailed handling
          throw error;
        });
      }
      return response.json();
    })
    .catch((err) => {
      console.error("Address validation service error:", err);
      // Ensure the error is propagated so the UI can react to it.
      throw err;
    });
};

/**
 * Get KML boundaries for map display
 */

const getMapBoundaries = (entityId, lob) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/kml/map-boundaries?entityId=${entityId}&lob=${lob}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (!response.ok) {
        return response.json().then((errorData) => {
          throw new Error(errorData.message || "Failed to fetch map boundaries");
        });
      }
      return response.json();
    })
    .catch((err) => {
      console.error("Map boundaries service error:", err);
      throw err;
    });
};

/**
 * Compile full address from form fields
 */

const compileAddressFromFields = (addressData) => {
  const { streetAddress, city, state, zip } = addressData;
  const parts = [];

  if (streetAddress?.trim()) parts.push(streetAddress.trim());
  if (city?.trim()) parts.push(city.trim());
  if (state?.trim()) parts.push(state.trim());
  if (zip?.trim()) {
    // Handle zip format like "12345 (City Name)"
    const zipOnly = zip.includes("(") ? zip.split(" (")[0] : zip;
    parts.push(zipOnly.trim());
  }

  return parts.join(", ");
};

/**
 * Get available service areas for entity/LOB
 */

const getServiceAreas = (entityId, lob) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(`${apiBase}/tel/kml/service-areas?entityId=${entityId}&lob=${lob}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (!response.ok) {
        return response.json().then((errorData) => {
          throw new Error(errorData.message || "Failed to fetch service areas");
        });
      }
      return response.json();
    })
    .catch((err) => {
      console.error("Service areas service error:", err);
      throw err;
    });
};

/**
 * Test address against specific KML file (for debugging)
 */

const testAddressAgainstKML = (data) => {
  let body = { ...data };

  if (process.env.NODE_ENV !== "production") {
    body = {
      ...body,
      jwtCookie: cookieService.get("token"),
    };
  }

  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(body),
  };

  let apiBase = getApiBase();

  return fetch(`${apiBase}/tel/kml/test-address`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (!response.ok) {
        return response.json().then((errorData) => {
          throw new Error(errorData.message || "Address test failed");
        });
      }
      return response.json();
    })
    .catch((err) => {
      console.error("Address test service error:", err);
      throw err;
    });
};

/**
 * Upload KML file
 */

const uploadKMLFile = (formData) => {
  // Add JWT cookie for non-production environments
  if (process.env.NODE_ENV !== "production") {
    formData.append("jwtCookie", cookieService.get("token"));
  }

  const parameters = {
    method: "POST",
    credentials: "include",
    body: formData, // Don't set Content-Type header for FormData
  };

  let apiBase = getApiBase();

  return fetch(`${apiBase}/tel/kml/upload`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (!response.ok) {
        return response.json().then((errorData) => {
          throw new Error(errorData.message || "KML upload failed");
        });
      }
      return response.json();
    })
    .catch((err) => {
      console.error("KML upload service error:", err);
      throw err;
    });
};

/**
 * Get KML files for entity/LOB
 */

const getKMLFiles = (entityId, lob, regionId = null, marketId = null) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `&jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  let queryParams = `entityId=${entityId}&lob=${lob}`;
  if (regionId) queryParams += `&regionId=${regionId}`;
  if (marketId) queryParams += `&marketId=${marketId}`;

  return fetch(`${apiBase}/tel/kml/files?${queryParams}${jwtCookie}`, parameters)
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (!response.ok) {
        return response.json().then((errorData) => {
          throw new Error(errorData.message || "Failed to fetch KML files");
        });
      }
      return response.json();
    })
    .catch((err) => {
      console.error("Get KML files service error:", err);
      throw err;
    });
};

/**
 * Get specific KML file
 */

const getKMLFile = (entityId, regionId, marketId, lob) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(
    `${apiBase}/tel/kml/file/${entityId}/${regionId}/${marketId}?lob=${lob}${
      jwtCookie ? "&" + jwtCookie.substring(1) : ""
    }`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (!response.ok) {
        return response.json().then((errorData) => {
          throw new Error(errorData.message || "Failed to fetch KML file");
        });
      }
      return response.json();
    })
    .catch((err) => {
      console.error("Get KML file service error:", err);
      throw err;
    });
};

/**
 * Delete KML file
 */

const deleteKMLFile = (entityId, regionId, marketId, lob) => {
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(
    `${apiBase}/tel/kml/file/${entityId}/${regionId}/${marketId}?lob=${lob}${
      jwtCookie ? "&" + jwtCookie.substring(1) : ""
    }`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (!response.ok) {
        return response.json().then((errorData) => {
          throw new Error(errorData.message || "Failed to delete KML file");
        });
      }
      return response.json();
    })
    .catch((err) => {
      console.error("Delete KML file service error:", err);
      throw err;
    });
};

/**
 * Get folder structure for entity/LOB
 */

const getFolderStructure = (entityId, lob) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(
    `${apiBase}/tel/kml/folder-structure/${entityId}?lob=${lob}${jwtCookie ? "&" + jwtCookie.substring(1) : ""}`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (!response.ok) {
        return response.json().then((errorData) => {
          throw new Error(errorData.message || "Failed to fetch folder structure");
        });
      }
      return response.json();
    })
    .catch((err) => {
      console.error("Folder structure service error:", err);
      throw err;
    });
};

/**
 * Get regions for entity/LOB
 */

const getRegions = (entityId, lob) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(
    `${apiBase}/tel/kml/regions/${entityId}?lob=${lob}${jwtCookie ? "&" + jwtCookie.substring(1) : ""}`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (!response.ok) {
        return response.json().then((errorData) => {
          throw new Error(errorData.message || "Failed to fetch regions");
        });
      }
      return response.json();
    })
    .catch((err) => {
      console.error("Get regions service error:", err);
      throw err;
    });
};

/**
 * Get markets for entity/LOB/region
 */

const getMarkets = (entityId, regionId, lob) => {
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  let apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `?jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  return fetch(
    `${apiBase}/tel/kml/markets/${entityId}/${regionId}?lob=${lob}${jwtCookie ? "&" + jwtCookie.substring(1) : ""}`,
    parameters
  )
    .then((response) => {
      if (response.status === 403) {
        throw new Error("Invalid Auth Token");
      }
      if (!response.ok) {
        return response.json().then((errorData) => {
          throw new Error(errorData.message || "Failed to fetch markets");
        });
      }
      return response.json();
    })
    .catch((err) => {
      console.error("Get markets service error:", err);
      throw err;
    });
};

export const telecomClaimService = {
  getAllClaims,
  getMyClaims,
  getMyTeamsClaims,
  getMyMobileClaims,
  getClaimById,
  getRelatedClaims,
  updateClaim,
  deleteClaim,
  createClaim,
  getCreateClaimFieldRules,
  getSchemaEntityOptions,
  getSchemaRdaOptions,
  getFilterSets,
  createFilterSet,
  removeFilterSet,
  updateFilterSet,
  checkFilterSetName,
  duplicateFilterSet,
  uploadFile,
  handleSaveRotation,
  getFiles,
  sortOrder,
  updateCategory,
  getSignedUrl,
  logFileAccess,
  postPayment,
  getClaimHistory,
  getJobCostingInvoice,
  getClaimJobCostingRateCardContractor,
  getClaimJobCostingRateCardMaterial,
  getClaimJobCostingRateCardLabor,
  putConstructionCostsCompleted,
  getClaimJobCostingFlatRates,
  claimInvoiceTimeStamp,
  postClaimInHouseLaborItem,
  postClaimMaterialItem,
  postClaimOtherItem,
  postClaimUnlistedItem,
  postClaimContractorItem,
  postClaimLOItem,
  getClaimRepairCosts,
  postRepairCostLabor,
  postRepairCostMaterial,
  deleteRepairCostLabor,
  deleteRepairCostMaterial,
  jobCostingRemoveOtherItem,
  jobCostingRemoveLaborItem,
  jobCostingRemoveMaterialItem,
  jobCostingRemoveContractorItem,
  jobCostingRemoveLOItem,
  getCostingStatusOptions,
  uploadJobCostingFile,
  claimUploadDocument,
  checkUploadStatus,
  claimConvertDocument,
  getInvoiceDoc,
  getClaimDoc,
  getClaimDocSchemaReason,
  getClaimDocSchemaContacts,
  getClaimDocSchemaLastSentence,
  getClaimAttachmentSchemaImageCategory,
  getClaimAttachmentSchemaVideoCategory,
  getClaimAttachmentSchemaDocumentCategory,
  getClaimDocSchemaDigLaws,
  getClaimNarrativeCreatorDoc,
  getClaimIntentToBillDoc,
  getClaimPromissoryNoteDoc,
  getClaimLegalFinalNoticeDoc,
  getClaimFinalNoticeDoc,
  getClaimReleaseLetterDoc,
  getClaimSecondNoticeDoc,
  getClaimPaymentReceiptDoc,
  getClaimBalanceOwedDoc,
  getClaimPreLegalLetterDoc,
  deleteLedger,
  updateLedger,
  deleteStatusNote,
  deleteActionNote,
  addClaimDocSchemaReason,
  editClaimDocSchemaReason,
  removeClaimDocSchemaReason,
  saveColumnFilters,
  //getLogo
  validateAddress,
  getServiceAreas,
  testAddressAgainstKML,
  uploadKMLFile,
  getKMLFiles,
  getKMLFile,
  deleteKMLFile,
  getFolderStructure,
  getRegions,
  getMarkets,
  getMapBoundaries,
  compileAddressFromFields,
  createWordDoc,
};
